<div class="form-details">
  <ws10-text-header *ngIf="textHeaderConfig" [textHeaderConfig]="textHeaderConfig">
  </ws10-text-header>
  <ws10-grid *ngIf="!noFieldsReturned">
    <ws10-grid-column [gridColumnConfig]="gridColumnConfig">
      <ws10-notification class="form-details__captcha-notification" *ngIf="captchaError && captchaErrorNotification" [notificationConfig]="captchaErrorNotification"></ws10-notification>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <ng-template viewContainer=""></ng-template>
        <div class="form-details__captcha">
          <ws10-captcha required formControlName="captcha"
            [captchaConfig]="captchaConfig" (xCaptcha)="onCaptchaLoad($event)"></ws10-captcha>
        </div>
        <div *ngIf="submitBtnConfig" class="form-details__submit-button">
          <ws10-button *ngIf="submitBtnConfig" [ws10Button]="submitBtnConfig" (onClick)="onSubmit()"></ws10-button>
        </div>
        <div *ngIf="backBtnConfig" class="form-details__back-button">
          <ws10-button [ws10Button]="backBtnConfig" (onClick)="onBackBtnClick()"></ws10-button>
        </div>
      </form>
    </ws10-grid-column>
  </ws10-grid>

  <!-- div for no fields returned -->
  <div *ngIf="noFieldsReturned" class="text-center form-details__no-fields">
    <svg class=" mid icon-plus-i-lrg i-lrg">
      <use xlink:href="/simplicity/simplicity-smaller/svgs/svgdefs.svg#i-case-study-mid-lrg" />
    </svg>
    <div class="eq-body">
      <h3 class="center-footer" [innerHtml]="'FromCenterModule.formRendering.emptyForm.std-headline' | translate">
      </h3>
    </div>
  </div>

</div>
